const API_BASE_URL = (import.meta.env.VITE_API_URL || '').replace(/\/+$/, '');

function getErrorMessage(data) {
  if (data && typeof data === 'object' && typeof data.message === 'string') {
    return data.message;
  }

  return 'Paketler yuklenirken beklenmeyen bir hata olustu.';
}

export async function fetchPublicPlanPrices(billingPeriod) {
  const query = new URLSearchParams();
  if (billingPeriod) {
    query.set('billingPeriod', billingPeriod);
  }

  const queryText = query.toString();
  const endpoint = `${API_BASE_URL}/api/public/pricing/plan-prices${queryText ? `?${queryText}` : ''}`;
  const response = await fetch(endpoint, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    let errorData = null;
    try {
      errorData = await response.json();
    } catch {
      errorData = null;
    }

    throw new Error(getErrorMessage(errorData));
  }

  const data = await response.json();
  return Array.isArray(data) ? data : [];
}
